<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import locationServices from '@/services/api/location.api';
import reportServices from '@/modules/report/api';
import documentServices from '@//modules/report/document';

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: '',
      routes: [],
    },
    model: {
      search: {
        collections: {
          centers: [],
        },
        filters: {
          centers: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'centers',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Centro:',
          placeholder: 'Seleccionar',
          class: 'col-md-10',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.centers,
        },
      ];
    },
  },
  async mounted() {
    this.setFilters();
    if (this.$route.name == 'Indicator11') {
      this.page.title = 'Indicador 11';
      this.page.routes = ['Informes', 'Indicador 11'];
    } else {
      this.page.title = 'Indicador 12';
      this.page.routes = ['Informes', 'Indicador 12'];
    }
  },
  methods: {
    async setFilters() {
      await locationServices
        .getAllCenters()
        .then((res) => (this.model.search.collections.centers = res.data));
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (isValid) {
        this.process();
      }
    },
    async process() {
      var filterSelected =
        this.model.search.filters.centers == null
          ? 'Todos'
          : this.model.search.filters.centers.name;

      let reportName = this.$route.name + '_center_' + filterSelected + '.xlsx';

      let fileName = 'InformeIndicador11.xlsx';

      if (this.$route.name == 'Indicator12')
        fileName = 'InformeIndicador12.xlsx';

      await reportServices
        .getReport('indicator', {
          DirectoryName: 'ind11-12reports',
          ReportName: reportName,
          FileName: fileName,
        })
        .then((res) => documentServices.Download(res.data));
    },
  },
};
</script>
